import { FilmTile } from "@components/film/FilmTile"
import { NewsTile } from "@components/news/NewsTile"
import { Button } from "@components/ui/Button"
import { tv } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link, useRoute } from "eddev/routing"
import { NewsItemHeaderSingleFragment, NewsItemMinimalFragment } from "../../types.graphql"

export const meta: BlockMeta = {
  title: "Related News",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("news/related-news", (props) => {
  const styles = createStyles()
  const route = useRoute()

  const items =
    props.category?.newss?.nodes ||
    (props.news?.newsHeader?.category?.contentNodes?.nodes as unknown as (NewsItemMinimalFragment &
      NewsItemHeaderSingleFragment)[]) ||
    []

  return (
    <div className={styles.wrapper()}>
      {/* Heading/CTA */}
      <div className="flex justify-between items-center mb-7 md:mb-4">
        <EditableText
          store="title"
          as="h4"
          className="type-title-s uppercase"
          placeholder="Related News"
          defaultValue="Related News"
          plainText
        />
        <Button href="/news" variant="link">
          <EditableText store="cta" as="span" placeholder="View all" defaultValue="View all" plainText />
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-7 md:gap-4">
        {items
          ?.filter((n) => {
            const uri = n.uri?.charAt(n.uri.length - 1) === "/" ? n.uri.slice(0, -1) : n.uri
            const pathname =
              route.pathname.charAt(route.pathname.length - 1) === "/" ? route.pathname.slice(0, -1) : route.pathname
            return uri !== pathname
          })
          .slice(0, 4)
          .map((item, i) => (
            <div key={i} className={styles.item()}>
              <NewsTile item={item} hideExcerpt />
            </div>
          ))}
      </div>
    </div>
  )
})

const createStyles = tv({
  slots: {
    wrapper: "p-4 my-10",
    item: "col-span-1",
  },
})
